import React, { useCallback, useState } from "react";
import { updateCollection } from "../../services/firebase";
import { FIREBASE_COLLECTION_DOC_KEY, FIREBASE_COLLECTION_KEY, ROUTE_PATHS } from "../../constants";
import { useNavigate, useParams } from "react-router-dom";
import {
  getGuessTableAddEditInitialState,
  getCurrentDayGames,
  getLastDigitOfANumber,
  sumOfDigits,
  isEmpty,
  nextNumericId,
} from "../../util";
import "./css/style.min.css";
import "./css/matkaplay.css";
import "../common.css";

const AddEditGuessingTableScreen = ({ data, guessingTableList }) => {
  const navigate = useNavigate();

  const params = useParams();

  const selectedGameIndex = params?.guessGameId ?? null;
  const [{ guessNumber, gameName, guessGameId, createdTime }, setState] = useState(
    getGuessTableAddEditInitialState(
      getCurrentDayGames(guessingTableList ?? []),
      selectedGameIndex
    )
  );

  // const createGuessTableAPICall = (body) => {
  //   APIService.post(API_CONFIGS.CREATE_GUESS_TABLE.URL, body)
  // };
  // const updateGuessTableAPICall = (body) => {
  //   APIService.post(API_CONFIGS.UPDATE_GUESS_TABLE.URL, body)
  // };

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  const handleAddGameSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!isEmpty(guessNumber)) {
        const stored = Array.isArray(data?.guessingTableData)
          ? [...data.guessingTableData]
          : [...(guessingTableList || [])];
        const gameObject = {
          gameName,
          guessNumber: guessNumber,
          winnerValue: getLastDigitOfANumber(
            sumOfDigits(Number.parseInt(guessNumber, 10))
          ).toString(),
          createdTime:
            selectedGameIndex === null
              ? new Date().toISOString()
              : createdTime || new Date().toISOString(),
        };
        let guessingTableData = stored;
        if (selectedGameIndex === null) {
          guessingTableData = [
            ...stored,
            {
              ...gameObject,
              guessGameId: nextNumericId(stored, "guessGameId"),
            },
          ];
        } else {
          const guessId = Number.parseInt(guessGameId ?? selectedGameIndex, 10);
          const foundIndex = stored.findIndex(
            (item) => item.guessGameId === guessId
          );
          const nextRecord = {
            ...(foundIndex >= 0 ? stored[foundIndex] : {}),
            ...gameObject,
            guessGameId: guessId,
            createdTime:
              foundIndex >= 0 ? stored[foundIndex].createdTime : gameObject.createdTime,
          };
          if (foundIndex >= 0) {
            guessingTableData = stored.map((item, index) =>
              index === foundIndex ? nextRecord : item
            );
          } else {
            guessingTableData = [...stored, nextRecord];
          }
        }

        updateCollection(FIREBASE_COLLECTION_KEY, FIREBASE_COLLECTION_DOC_KEY, {
          guessingTableData,
        })
          .then(() => {
            navigate(ROUTE_PATHS.HOME);
            window.location.reload();
          })
          .catch((error) => {
            console.error("firebase guessing table save failed", error);
            alert("Could not save the guessing result in Firebase.");
          });
        //   });
      } else {
        alert("Enter the 3 digit game numbers.");
      }
    },
    [data, guessingTableList, navigate, guessNumber, gameName, createdTime, guessGameId, selectedGameIndex]
  );

  return (
    <div className="login">
      <div className="container round_border_card">
        <h2 className="text-center">
          {selectedGameIndex === null
            ? "Add New Guessing Result"
            : "Update Guessing Result Detail"}
        </h2>
        <br />
        <form
          name="adminAddFatafatResultGame"
          validate
          onSubmit={handleAddGameSubmit}
          className="loginForm"
        >
          <div className="input-group mt-2">
            {/* <label className="label">Game Result</label> */}
            <div className="input-group mt-2">
            <label className="label">Game Name</label>
            <input
              // type="number"
              id="gameName"
              name="gameName"
              className="form-control"
              placeholder="Enter the game name"
              minLength={3}
              onChange={handleChange}
              value={gameName}
            />
            <span className="error-message"></span>
          </div>
          <div style={{ marginTop: 10}}>
            <input
              type="number"
              id="guessNumber"
              name="guessNumber"
              className="form-control"
              placeholder="Enter 3 digit game numbers"
              maxLength={3}
              minLength={3}
              onChange={handleChange}
              value={guessNumber}
            />
            <span className="error-message"></span>
            </div>
          </div>
          <br />
          <button className="button btn btn-custom btn-lg" type="submit">
            {selectedGameIndex === null ? "Add" : "Update"}
          </button>
          <button
            className="button btn btn-custom btn-lg mt-2 ml-0"
            onClick={() => navigate(ROUTE_PATHS.HOME)}
            style={{ marginTop: "10px" }}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddEditGuessingTableScreen;
